import { Component, OnInit } from '@angular/core';
import { Products } from '../../models/product';
import { ProductsService } from '../../services/products.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'products-featured-products',
  templateUrl: './featured-products.component.html',
  styles: [],
})
export class FeaturedProductsComponent implements OnInit {
  featuredProducts: Products[] = [];
  endsubs$: Subject<any> = new Subject();

  constructor(private productService: ProductsService) {}

  ngOnInit(): void {
    this._getFeaturedProducts();
  }

  private _getFeaturedProducts() {
    this.productService
      .getFeaturedProducts(4)
      .pipe(takeUntil(this.endsubs$))
      .subscribe((products) => {
        this.featuredProducts = products;
      });
  }

  ngOnDestroy() {
    this.endsubs$.complete();
  }
}
